import { FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";

import validateDomain from "../../../../../helpers/validateDomain";
import { useScimWizardContext } from "../../../../../providers/ScimWizardProvider";
import CoAppAzureIdpIcon from "../../../../global/components/icons/CoAppAzureIdpIcon";
import CoAppMultiSelect from "../../../../global/components/inputs/CoAppMultiSelect";
import { SsoDomainContainer } from "../../../../global/styled/global.styled";
import { ScimWizardIdpContainer, ScimWizardStepContainer } from "../styled/scim-wizard.styled";

export default function Step1() {
	const { domainError, setDomainError, companyDomains,
		setCompanyDomains, identityProviderName, inUseDomains,
		organizationId 
	} = useScimWizardContext();

	const handleCompanyDomainChange = (_: any, value: any) => {
		const lastDomain = value[value.length - 1];

		const domainAlreadyExists = inUseDomains.find((domain: any) => domain.name.toLowerCase() === lastDomain?.toLowerCase() && domain.organizationId !== organizationId);
		const isValidOrEmpty = validateDomain(lastDomain) || !lastDomain;
		if (isValidOrEmpty && !domainAlreadyExists) {
			setCompanyDomains([...new Set(value as string[])]);
			setDomainError("");
		} else {
			if (domainAlreadyExists) {
				setDomainError(`"${lastDomain}" is already in use`);
			} else {
				setDomainError(`"${lastDomain}" is not a valid domain`);
			}
		}
	};

	return (
		<ScimWizardStepContainer spacing={4}>
			<Typography variant="h5">Enter your company SAML domain(s)</Typography>
			<SsoDomainContainer>
				<CoAppMultiSelect
					label="Company domains"
					options={[]}
					onChange={handleCompanyDomainChange}
					value={companyDomains}
					helperText={domainError !== "" ? domainError : "Required *"}
					error={domainError !== ""}
					isFreeSolo={true}
				/>
			</SsoDomainContainer>
			<Typography variant="h5">{"Select your identity provider (IdP)"}</Typography>
			<RadioGroup
				value={identityProviderName}
			>
				<ScimWizardIdpContainer>
					<CoAppAzureIdpIcon sx={{ position: "absolute", left: 60 }} />
					<FormControlLabel
						sx={{ position: "absolute", top: 110, left: 25 }}
						control={
							<Radio />
						}
						label="Microsoft Entra ID"
						labelPlacement="top"
						value="Azure"
					/>
				</ScimWizardIdpContainer>
			</RadioGroup>
		</ScimWizardStepContainer >
	);
}